
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import { Order } from "@/script/apps/shop/entity/ShopEntity";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { DictUtil } from "@/script/core/Dict";
import { OrderService } from "@/script/apps/shop/service/OrderService";
import { ElMessage, ElMessageBox } from "element-plus";
import { AppConfig } from "@/script/core/base/AppConfig";
import axios from "axios";

@Options({})
export default class OrderDetail extends BaseDetail {
  private service = new OrderService();

  public initData(): ServiceContext {
    const data = ServiceFactory.build(
      "biz_shop_order",
      "/shop/order",
      "/shop/order",
      this.service
    );
    data.entity = {
      user: { realName: "" },
    };
    data.statesName = "shop-order-state";
    return data;
  }

  private rules = {
    code: [{ required: true, message: "请输入编码", trigger: "blur" }],
    name: [{ required: true, message: "请输入名称", trigger: "blur" }],
  };

  public newEntity() {
    const entity: Order = {};
    return entity;
  }

  private audit() {
    ElMessageBox.confirm("此操作将[审核订单], 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        const order = this.entity as Order;
        this.service.action(
          "/api/shop/order/audit",
          order,
          (data: any) => {
            ElMessage({ type: "success", message: data.message });
            this.load(this.id);
          },
          function (error: Error) {
            ElMessage.error(error.message);
          }
        );
      })
      .catch(() => {
        ElMessage({
          type: "info",
          message: "已取消操作",
        });
      });
  }

  private exportExcel() {
    const self = this;
    const fileName = "标物订单-" + self.entity.code + ".xlsx";
    this.service
      .exportExcel(
        "/api/shop/order/excel/export",
        { id: this.entity.id },
        fileName
      )
      .then(
        function (status: any) {
          
        },
        function (error: Error) {
          console.error(error);
        }
      );
  }
}
